import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskUnassignedTicketTypesConfigRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-unassigned-ticket-types-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned',
};
